<template>
  <div class="col-12 mb-4" @click="toggleActive" :class="classes">
    <div class="wizard-building-type w-100 d-flex justify-content-center" :class="this.isActive ? 'selected' : ''">
      <p class="text-nowrap">
        <img class="wizard-building-image" :src="src" />
        <span>{{ this.name }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "isActive"],

  computed: {
    classes() {
      return [`col-sm-6`, `col-md-4`, `col-lg-6`, `col-xl-4`];
    },

    src() {
      return this.isActive ? "/images/property_icon_selected.svg" : "/images/property_icon.svg";
    },
  },

  methods: {
    toggleActive() {
      this.$emit("onToggle");
    },
  },
};
</script>
